import pug from 'javascripts/core_post_webpack/sitewide_business_elements/bookmarks/templates/settings_link.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/bookmarks/templates/settings_link'
] = pug;
